import React from 'react';
import { Heart, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { useWatchlist } from '../hooks/useWatchlist';

const WatchlistButton = ({ 
  videoId, 
  videoTitle = '', 
  size = 'sm', 
  variant = 'outline',
  showText = true,
  className = ''
}) => {
  const { isInWatchlist, toggleWatchlist, loading } = useWatchlist();
  
  const inWatchlist = isInWatchlist(videoId);
  
  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    await toggleWatchlist(videoId, videoTitle);
  };

  return (
    <Button
      size={size}
      variant={variant}
      onClick={handleClick}
      disabled={loading}
      className={`flex items-center space-x-2 ${inWatchlist 
        ? 'bg-pink-600 hover:bg-pink-700 border-pink-600 text-white' 
        : 'hover:bg-pink-600/20 hover:border-pink-500'
      } ${className}`}
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Heart 
          className={`h-4 w-4 ${inWatchlist ? 'fill-white' : ''}`} 
        />
      )}
      {showText && (
        <span className="hidden sm:inline">
          {inWatchlist ? 'Dans la watchlist' : 'Ajouter à la watchlist'}
        </span>
      )}
    </Button>
  );
};

export default WatchlistButton;